import { Evnt_dispatch } from '../Evnt/Evnt.dispatch'

export function E2E_waitForResumeSaveBlob() {
    Evnt_dispatch('E2E_SaveBlobPaused')
    return waitForEvent('E2E_ResumeSaveBlob')
}

export function E2E_waitForResumeReportDone() {
    Evnt_dispatch('E2E_ReportDonePaused')
    return waitForEvent('E2E_ResumeReportDone')
}

function waitForEvent(eventName: string) {
    return new Promise<void>((resolve) => window.addEventListener(eventName, () => resolve(), true))
}
